<div class="c-card">
	<div class="c-content u-no-p@up-to-md">
		<table-created-surveys [(surveys)]="vm.surveys" [questionnaireCode]="vm.questionnaireCode" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></table-created-surveys>
	</div>
	<div *ngIf="vm.surveys && vm.surveys?.length > vm.pageSize">	
		<div class="o-grid u-ost-md u-osb-md">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
				<list-pager [totalItems]="vm.surveys?.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
			</div>
		</div>
	</div>
</div>
